<template>
  <div class="offers" id="offers">
    <div>
      <p class="offers__intro">Every office manager has different coffee needs. Whether you’re a coffee connoisseur (Never Settler), cost-conscious shopper (Economist) or a multi-tasking master (Busy Bee), we have support to make coffee easier and more satisfying than ever.</p>
    </div>
    <ul>
      <li
        v-for="(format, index) in offersChecked"
        :key="index"
      >
        <Offer :format="format" :tags='tags(format.slug)' />
      </li>
    </ul>
    <!-- <div v-if="pageMode === 'suppliers'" class="offer-form-wrapper">
      <button
        v-if="!toggleOffers"
        class="button button--green"
        type="button"
        @click="showOfferForm"
      >
        Get Offers
      </button>
      <LeadForm type="suppliers" v-if="toggleOffers" @executeRC="executeRC" @resetRC="resetRC" />
    </div> -->
  </div>
</template>

<script>
import { pageMode } from '../../mixins/pageMode.js'
import Offer from './Offer.vue'
// import LeadForm from '../Form/LeadForm.vue'
// import { assetPath } from '../../mixins/assetPath.js'

export default {
  name: 'OfferContainer',
  components: {
    Offer,
    // LeadForm
  },
  props: {
    forced: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      toggleOffers: false,
      sets: {
        'never-settler': {
          'all': ['portfolio-guide', 'coffee-talk-kit', 'office-brewing-guide', 'office-coffee-safety-guide'],
          'label': "The Never Settler"
        },
        'economist': {
          'all': ['portfolio-guide', 'coffee-talk-kit', 'office-brewing-guide', 'office-coffee-safety-guide'],
          'label': "The Economist"
        },
        'busy-bee': {
          'all': ['portfolio-guide', 'coffee-talk-kit', 'office-brewing-guide', 'office-coffee-safety-guide'],
          'label': "The Busy Bee"
        }
      },
      offers: [
        {
          name: 'Customer Match Tool',
          shortName: 'Tool',
          slug: 'customer-match-tool',
          physical: false,
          download: 'pdf/JMS-OCS-Operator-Match-Tool.pdf',
          icon: 'materials/download-coffee_match_tool.png',
          permission: ['suppliers'],
          supplierCopy: 'A guide to offering the right kind of coffee and support to three different kinds of offices.',
        },
        {
          name: 'Portfolio Guide',
          shortName: 'Guide',
          slug: 'portfolio-guide',
          physical: false,
          download: 'pdf/OCS-Portfolio-Guide.pdf',
          icon: 'materials/download-portfolio_guide.png',
          permission: ['managers'],
          managerCopy: 'No time for the quiz, or want to save your results? Download this simple guide to determine the best roasts and formats for your office.'
        },
        {
          name: 'Coffee Talk Kit',
          shortName: 'Kit',
          slug: 'coffee-talk-kit',
          physical: false,
          download: 'pdf/JMS-OCS-Coffee-Talk-Starter-Pack.pdf',
          icon: 'materials/download-coffee_talk_kit.png',
          permission: ['managers', 'suppliers'],
          supplierCopy: 'Office games, coffee service tips and breakroom signage to build office comradery.',
          managerCopy: 'Get tailored recommendations, a tasting guide, printable signage for coffee stations, fun office games and more to get your office buzzing about coffee.'
        },
        {
          name: 'Office Brewing Guide',
          shortName: 'Guide',
          slug: 'office-brewing-guide',
          physical: false,
          download: 'pdf/JMS_OCS_CoffeeBrewingGuide.pdf',
          icon: 'materials/download-office_brewing_guide.png',
          permission: ['managers', 'suppliers'],
          supplierCopy: `Get the rundown on the popular brewing methods for offices of every size and find the right fit for your customers.`,
          managerCopy: `From drip to ready-made lattes and iced coffees, check out all your great brewing options.`
        },
        // {
        //   name: 'Office Coffee Safety Guide',
        //   shortName: 'Guide',
        //   slug: 'office-coffee-safety-guide',
        //   physical: false,
        //   download: 'pdf/OCS_Self-Service_Breakroom Support.pdf',
        //   icon: 'materials/download-office_coffee_safety_guide.png',
        //   permission: ['managers', 'suppliers'],
        //   supplierCopy: 'Get tips for maintaining safe and sanitary coffee service in the office.',
        //   managerCopy: 'Is your office just getting back to more days in the office? This handy guide provides helpful ways to keep your coffee station(s) clean and sanitary.'
        // },
        // {
        //   name: 'Welcome Back Kit',
        //   shortName: 'Kit',
        //   slug: 'welcome-back-kit',
        //   physical: false,
        //   download: 'pdf/Welcome_Back_Kit.pdf',
        //   icon: 'materials/WelcomeBackKit.png',
        //   permission: ['managers', 'suppliers'],
        //   supplierCopy: `Icebreakers and helpful break room signage to bring back the office comradery.`,
        //   managerCopy: `Icebreakers and helpful break room signage to bring back the office comradery.`,
        // },
        // {
        //   name: 'Free Select Brew® Setup',
        //   shortName: 'Setup',
        //   slug: 'free-select-brew-setup',
        //   physical: false,
        //   icon: 'materials/Select-Brew-Setup.png',
        //   permission: ['managers', 'suppliers'],
        //   link: 'https://smuckerawayfromhome.com/contact',
        //   supplierCopy: `From drip to ready-made lattes and iced coffees, walk your customers through their brewing options.`,
        //   managerCopy: `Have a quick chat with a rep and we’ll find the right machine for your office and set it up for free.`
        // },
        // {
        //   name: 'Free Filter Pack Sample',
        //   shortName: 'Sample',
        //   slug: 'free-filter-pack-sample',
        //   physical: true,
        //   icon: 'materials/Folgers-Filter-Image.png',
        //   permission: ['managers', 'suppliers'],
        //   supplierCopy: `Easy, safe and always fresh. Just put a <strong>Folgers<sup>®</sup></strong> Filter Pack in the brew basket and start brewing.`,
        //   managerCopy: `Easy, safe and always fresh. Just put a <strong>Folgers<sup>®</sup></strong> Filter Pack in the brew basket and start brewing.`,
        // },
        // {
        //   name: 'Roast Sample Kit',
        //   shortName: 'Sample Kit',
        //   slug: 'roast-sample-kit',
        //   physical: true,
        //   permission: ['managers', 'suppliers'],
        //   icon: 'materials/roast-sample-kit.png',
        //   supplierCopy: `Get samples of premium roasts from <strong>Caf&eacute; Bustlo<sup>®</sup></strong> and <strong>1850<sup>®</sup></strong> along with a tasting guide to seal the sale.`,
        //   managerCopy: `Get samples of premium <strong>Caf&eacute; Bustlo<sup>&reg;</sup></strong> and <strong>1850<sup>&reg;</sup></strong> roasts with a guide to set up an office tasting.`
        // },
      ],
    }
  },
  computed: {
    persona() {
      return this.$store.state.results.personaCalculated
    },
    employeeNumber() {
      return this.$store.state.quiz.number
    },
    offersCalculated() {
      if (this.persona) {
        return this.offers.filter((r) => {
          // console.log('r', r.slug)
          // console.log('asdf', this.sets[this.persona]['all'].includes(r.slug))
          return this.sets[this.persona]['all'].includes(r.slug)
        })
      } else if (this.forced) {
        if (this.forced === 'offers') {
          return this.offers.filter((r) => {
            return r.physical === true
          })
        } else if (this.forced === 'support') {
          return this.offers.filter((r) => {
            return r.physical === false
          })
        } else {
          return this.offers.filter((r) => {
            return this.sets[this.forced]['all'].includes(r.slug)
          })
        }
      } else {
        return this.offers
      }
    },
    locked () {
      return this.$store.state.offersUnlocked
    },
    offersChecked() {
      return this.offersCalculated.filter((o) => {
        return o.permission.includes(this.pageMode)
      })
    }
  },
  mounted() {
    this.$store.dispatch('completeUnlockAction', true) // for V3 of OCS, removing physical offers, and unlocking all downloads
  },
  methods: {
    width(count) {
      return 100/count
    },
    showOfferForm() {
      this.toggleOffers = true
    },
    resetRC() {
      this.$emit('resetRC')
    },
    executeRC() {
      // console.log('executeRC', 'offerContainer')
      this.$emit('executeRC')
    },
    tags(slug) {
      let tags = []
      for (const set in this.sets) {
        if (this.sets[set]['all'].includes(slug)) {
          tags.push(this.sets[set].label)
        }
      }
      return tags
    },
  },
  mixins: [pageMode]
}
</script>

<style lang="scss">

.offers {
  & > ul {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
    background-color: white;
  }
  @include breakpoint(medium down) {
    & > ul {
      & > li {
        // width: 100% !important;
        // flex-basis: 100% !important;
        border-bottom: 1px solid $grayer;
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
  @include breakpoint(large) {
    & > ul {
      flex-flow: row wrap;
      display: flex;
      justify-content: center;
      padding: 1em 0;
      & > li {
        flex: 1 0 20em;
        border-left: 1px solid $grayer;
        &:first-child {
          border-left: none;
        }
      }
    }
  }
}

.offer-form-wrapper {
  text-align: center;
  padding-bottom: 3em;
}

.offers__intro {
  max-width: 654px;
  margin: 1em auto;
  font-size: 1em;
  line-height: 1.25;
  text-align: center;
  color: #8A8B8D;
}

</style>